import gql from 'graphql-tag'

export default gql`
  query getSearchHistory($storeId: Int!) {
    getSearchHistory(storeId: $storeId) {
      data {
        id
        keyword
      }
    }
  }
`
